// Assinatura eletronica de propostas, num lugar so.
//
// Antes isso existia escrito a mao na PropostaDetalhe (servico) e eu havia
// escrito uma SEGUNDA versao na PropostaProduto - que ja divergiu na primeira
// regra: o botao "Assinar como Celum" so deve aparecer DEPOIS que o cliente
// assina, porque ele vive dentro do painel de assinaturas, e esse painel so
// existe quando ha pelo menos uma assinatura.
//
// Duas pecas, porque elas vao em lugares diferentes da tela:
//   <PainelAssinaturas ... />  o card verde no topo, com o botao e o modal
//   <BotoesAssinatura ... />   os botoes da barra: gerar link e PDF assinado
import React, { useState, useRef } from 'react';
import { Card, Button, Input, Modal, Space, Tag, message } from 'antd';
import { SafetyCertificateOutlined, DownloadOutlined } from '@ant-design/icons';
import SignaturePad from 'signature_pad';
import api from '../services/api';

const ROTAS = {
  servico: {
    base: (id) => '/assinatura/proposta/' + id,
    // o PDF do servico tem rota propria para a versao assinada
    pdf: (id) => '/assinatura/proposta/' + id + '/pdf-assinado',
  },
  produto: {
    base: (id) => '/assinatura/produto/' + id,
    // o PDF do produto ja le as colunas de assinatura, entao e a mesma rota
    pdf: (id) => '/propostas-produtos/' + id + '/pdf',
  },
};

const dataBR = (v) => (v ? new Date(v).toLocaleDateString('pt-BR') : '');

export function PainelAssinaturas({ tipo, id, proposta, onMudou }) {
  const r = ROTAS[tipo] || ROTAS.servico;
  const [aberto, setAberto] = useState(false);
  const [modo, setModo] = useState('digitar');
  const [nome, setNome] = useState('');
  const canvasRef = useRef(null);
  const padRef = useRef(null);

  if (!proposta) return null;
  if (!proposta.assinatura_cliente && !proposta.assinatura_celum) return null;

  const abrir = () => {
    setAberto(true);
    setTimeout(() => {
      if (!canvasRef.current) return;
      padRef.current = new SignaturePad(canvasRef.current,
        { backgroundColor: 'rgb(255,255,255)', penColor: 'rgb(0,0,0)' });
      const c = canvasRef.current;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      c.width = c.offsetWidth * ratio;
      c.height = c.offsetHeight * ratio;
      c.getContext('2d').scale(ratio, ratio);
      padRef.current.clear();
    }, 500);
  };

  const assinar = async () => {
    let assinatura = '';
    if (modo === 'digitar') {
      if (!nome.trim()) { message.warning('Digite seu nome'); return; }
      const canvas = document.createElement('canvas');
      canvas.width = 600; canvas.height = 120;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, 600, 120);
      ctx.font = '48px Dancing Script';
      ctx.fillStyle = 'black';
      ctx.textAlign = 'center';
      ctx.fillText(nome, 300, 85);
      assinatura = canvas.toDataURL('image/png');
    } else {
      if (!padRef.current || padRef.current.isEmpty()) {
        message.warning('Faça sua assinatura'); return;
      }
      assinatura = padRef.current.toDataURL('image/png');
    }
    try {
      await api.post(r.base(id) + '/celum', { assinatura });
      message.success('Proposta assinada pela Celum!');
      setAberto(false); setNome(''); setModo('digitar'); padRef.current = null;
      if (onMudou) onMudou();
    } catch (e) { message.error(e.response?.data?.erro || 'Erro ao assinar'); }
  };

  return (<>
    <Card size="small" style={{ marginBottom: 16, background: '#f6ffed',
      border: '1px solid #b7eb8f' }}>
      <Space wrap>
        <span><strong>Assinaturas:</strong></span>
        {proposta.assinatura_cliente
          ? <Tag color="green">✓ Cliente: {proposta.assinatura_cliente_nome} — {dataBR(proposta.assinatura_cliente_em)}</Tag>
          : <Tag>Cliente: aguardando</Tag>}
        {proposta.assinatura_celum
          ? <Tag color="blue">✓ Celum: {proposta.assinatura_celum_nome} — {dataBR(proposta.assinatura_celum_em)}</Tag>
          : <Button size="small" type="primary" onClick={abrir}>Assinar como Celum</Button>}
      </Space>
    </Card>

    <Modal title="Assinar como Celum" open={aberto} footer={null}
      onCancel={() => { setAberto(false); padRef.current = null;
        setModo('digitar'); setNome(''); }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <Button type={modo === 'digitar' ? 'primary' : 'default'}
          onClick={() => setModo('digitar')}>Digitar nome</Button>
        <Button type={modo === 'desenhar' ? 'primary' : 'default'}
          onClick={() => { setModo('desenhar'); abrir(); }}>Desenhar</Button>
      </div>
      {modo === 'digitar' ? (
        <div>
          <Input placeholder="Digite seu nome completo" value={nome} size="large"
            style={{ marginBottom: 12 }} onChange={(e) => setNome(e.target.value)} />
          {nome && (
            <div style={{ border: '2px solid #0099FF', borderRadius: 8,
              backgroundColor: '#fff', padding: 20, textAlign: 'center', marginBottom: 12 }}>
              <span style={{ fontFamily: 'Dancing Script, cursive', fontSize: 36,
                color: '#000' }}>{nome}</span>
            </div>
          )}
          <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap"
            rel="stylesheet" />
        </div>
      ) : (
        <div>
          <p style={{ marginBottom: 8 }}>Faça sua assinatura abaixo:</p>
          <div style={{ border: '2px solid #0099FF', borderRadius: 8,
            backgroundColor: '#fff', marginBottom: 8 }}>
            <canvas ref={canvasRef} style={{ width: '100%', height: 180,
              display: 'block', touchAction: 'none' }} />
          </div>
          <Button size="small"
            onClick={() => padRef.current && padRef.current.clear()}>Limpar</Button>
        </div>
      )}
      <Button type="primary" block style={{ marginTop: 12 }}
        onClick={assinar}>Confirmar Assinatura</Button>
    </Modal>
  </>);
}

export function BotoesAssinatura({ tipo, id, proposta }) {
  const r = ROTAS[tipo] || ROTAS.servico;
  if (!id) return null;

  const gerarLink = async () => {
    try {
      const resp = await api.post(r.base(id) + '/gerar-token');
      try {
        await navigator.clipboard.writeText(resp.data.link);
        message.success('Link copiado! Envie para o cliente assinar.');
      } catch (e) {
        Modal.info({ title: 'Link de assinatura', width: 560,
          content: <Input readOnly value={resp.data.link}
            onFocus={(ev) => ev.target.select()} /> });
      }
    } catch (e) { message.error(e.response?.data?.erro || 'Erro ao gerar link'); }
  };

  const baixarAssinado = async () => {
    try {
      const resp = await api.get(r.pdf(id), { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([resp.data],
        { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', 'Proposta-' + (proposta?.numero || id) + '-Assinada.pdf');
      document.body.appendChild(a); a.click(); a.remove();
    } catch (e) { message.error('Erro ao gerar o PDF assinado'); }
  };

  return (<>
    <Button icon={<SafetyCertificateOutlined />} onClick={gerarLink}
      style={{ background: '#52c41a', borderColor: '#52c41a', color: 'white' }}>
      Link de assinatura</Button>
    {proposta?.assinatura_cliente && (
      <Button icon={<DownloadOutlined />} onClick={baixarAssinado}>PDF assinado</Button>
    )}
  </>);
}

export default PainelAssinaturas;
